/* Collections with tabs (sections/collections-with-tabs.liquid). Tabs, autoplay, hover and the
   crossfade come from mw-tabs (assets/tabs.js); this module adds the two Helix extras:
   - a collection with its own color scheme recolours the box (or the section when it is not
     boxed) while it is selected. The tab button carries data-scheme="color-…"; the recoloured
     element is [data-cwt-target] and keeps its own scheme in data-cwt-scheme for rows without one.
   - the featured-product strip slides in again each time a panel is shown (.cwt-enter).
   Listens on the document, so sections re-rendered by the theme editor need no set-up. */

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function schemeClass(el) {
  return [...el.classList].find((name) => name.startsWith('color-')) ?? '';
}

function onChange(event) {
  const tabs = event.target;
  if (!(tabs instanceof HTMLElement) || !tabs.classList.contains('cwt')) return;
  const { tab, panel } = event.detail ?? {};

  // The box (boxed) or the section (not boxed) carries data-cwt-target and its own scheme.
  const target = tabs.closest('[data-cwt-target]');
  if (target) {
    const wanted = tab?.dataset.scheme || target.dataset.cwtScheme || '';
    const current = schemeClass(target);
    if (wanted && wanted !== current) {
      if (current) target.classList.remove(current);
      target.classList.add(wanted);
    }
  }

  if (panel && !reducedMotion.matches) {
    panel.classList.remove('cwt-enter');
    void panel.offsetWidth;
    panel.classList.add('cwt-enter');
  }
}

document.addEventListener('mw:tabs:change', onChange);

/* The strip also slides in the first time the section scrolls into view (Helix). Until then
   CSS keeps it tucked into the corner (html.js only, never under reduced motion). */
const seen = 'IntersectionObserver' in window
  ? new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          seen.unobserve(entry.target);
          entry.target.classList.add('cwt--seen');
        });
      },
      { threshold: 0.25 }
    )
  : null;

function watch(root) {
  root.querySelectorAll('.cwt').forEach((el) => (seen ? seen.observe(el) : el.classList.add('cwt--seen')));
}

watch(document);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) watch(event.target);
});
